/* tslint:disable */
/* eslint-disable */
/**
 * MailSlurp API
 * MailSlurp is an API for sending and receiving emails from dynamically allocated email addresses. It\'s designed for developers and QA teams to test applications, process inbound emails, send templated notifications, attachments, and more.  ## Resources  - [Homepage](https://www.mailslurp.com) - Get an [API KEY](https://app.mailslurp.com/sign-up/) - Generated [SDK Clients](https://docs.mailslurp.com/) - [Examples](https://github.com/mailslurp/examples) repository
 *
 * The version of the OpenAPI document: 0.52458.0
 * Contact: contact@mailslurp.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
/**
 *
 */
export class IntegrationsControllerApi extends runtime.BaseAPI {
    /**
     * Create attachment action for Zapier
     */
    async zapierCreateAttachmentRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.filename !== undefined && requestParameters.filename !== null) {
            headerParameters['filename'] = String(requestParameters.filename);
        }
        if (requestParameters.contentType !== undefined && requestParameters.contentType !== null) {
            headerParameters['content-type'] = String(requestParameters.contentType);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/integrations/zapier/actions/create-attachment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.uploadOrganizationSettingsImageMultipartRequest,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create attachment action for Zapier
     */
    async zapierCreateAttachment(requestParameters = {}, initOverrides) {
        const response = await this.zapierCreateAttachmentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create contact action for Zapier
     */
    async zapierCreateContactRaw(requestParameters, initOverrides) {
        if (requestParameters.zapierActionCreateContactOptions === null || requestParameters.zapierActionCreateContactOptions === undefined) {
            throw new runtime.RequiredError('zapierActionCreateContactOptions', 'Required parameter requestParameters.zapierActionCreateContactOptions was null or undefined when calling zapierCreateContact.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/integrations/zapier/actions/create-contact`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.zapierActionCreateContactOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create contact action for Zapier
     */
    async zapierCreateContact(requestParameters, initOverrides) {
        const response = await this.zapierCreateContactRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create email action for Zapier
     */
    async zapierCreateEmailRaw(requestParameters, initOverrides) {
        if (requestParameters.zapierActionCreateEmailOptions === null || requestParameters.zapierActionCreateEmailOptions === undefined) {
            throw new runtime.RequiredError('zapierActionCreateEmailOptions', 'Required parameter requestParameters.zapierActionCreateEmailOptions was null or undefined when calling zapierCreateEmail.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/integrations/zapier/actions/create-email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.zapierActionCreateEmailOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create email action for Zapier
     */
    async zapierCreateEmail(requestParameters, initOverrides) {
        const response = await this.zapierCreateEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create inbox action for Zapier
     */
    async zapierCreateInboxRaw(requestParameters, initOverrides) {
        if (requestParameters.zapierActionCreateInboxOptions === null || requestParameters.zapierActionCreateInboxOptions === undefined) {
            throw new runtime.RequiredError('zapierActionCreateInboxOptions', 'Required parameter requestParameters.zapierActionCreateInboxOptions was null or undefined when calling zapierCreateInbox.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/integrations/zapier/actions/create-inbox`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.zapierActionCreateInboxOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create inbox action for Zapier
     */
    async zapierCreateInbox(requestParameters, initOverrides) {
        const response = await this.zapierCreateInboxRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create inbox action for Zapier
     */
    async zapierCreateInboxAliasRaw(requestParameters, initOverrides) {
        if (requestParameters.zapierActionCreateInboxAliasOptions === null || requestParameters.zapierActionCreateInboxAliasOptions === undefined) {
            throw new runtime.RequiredError('zapierActionCreateInboxAliasOptions', 'Required parameter requestParameters.zapierActionCreateInboxAliasOptions was null or undefined when calling zapierCreateInboxAlias.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/integrations/zapier/actions/create-inbox-alias`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.zapierActionCreateInboxAliasOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create inbox action for Zapier
     */
    async zapierCreateInboxAlias(requestParameters, initOverrides) {
        const response = await this.zapierCreateInboxAliasRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create inbox action for Zapier
     */
    async zapierCreateInboxForwarderRaw(requestParameters, initOverrides) {
        if (requestParameters.zapierActionCreateInboxForwarderOptions === null || requestParameters.zapierActionCreateInboxForwarderOptions === undefined) {
            throw new runtime.RequiredError('zapierActionCreateInboxForwarderOptions', 'Required parameter requestParameters.zapierActionCreateInboxForwarderOptions was null or undefined when calling zapierCreateInboxForwarder.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/integrations/zapier/actions/create-inbox-forwarder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.zapierActionCreateInboxForwarderOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create inbox action for Zapier
     */
    async zapierCreateInboxForwarder(requestParameters, initOverrides) {
        const response = await this.zapierCreateInboxForwarderRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete user Zapier connection
     */
    async zapierDeleteUserConnectionRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/integrations/zapier/connection`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete user Zapier connection
     */
    async zapierDeleteUserConnection(initOverrides) {
        await this.zapierDeleteUserConnectionRaw(initOverrides);
    }
    /**
     * Get zapier attachment records
     */
    async zapierGetNewAttachmentRecordsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/integrations/zapier/records/new-attachment`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get zapier attachment records
     */
    async zapierGetNewAttachmentRecords(requestParameters = {}, initOverrides) {
        const response = await this.zapierGetNewAttachmentRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get zapier contact records
     */
    async zapierGetNewContactRecordsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/integrations/zapier/records/new-contact`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get zapier contact records
     */
    async zapierGetNewContactRecords(requestParameters = {}, initOverrides) {
        const response = await this.zapierGetNewContactRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get zapier email records
     */
    async zapierGetNewEmailRecordsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/integrations/zapier/records/new-email`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get zapier email records
     */
    async zapierGetNewEmailRecords(requestParameters = {}, initOverrides) {
        const response = await this.zapierGetNewEmailRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get zapier inbox records
     */
    async zapierGetNewInboxRecordsRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }
        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }
        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/integrations/zapier/records/new-inbox`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get zapier inbox records
     */
    async zapierGetNewInboxRecords(requestParameters = {}, initOverrides) {
        const response = await this.zapierGetNewInboxRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Does user have Zapier connection
     */
    async zapierHasUserConnectionRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/integrations/zapier/connection`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Does user have Zapier connection
     */
    async zapierHasUserConnection(initOverrides) {
        const response = await this.zapierHasUserConnectionRaw(initOverrides);
        return await response.value();
    }
    /**
     * Test authentication for Zapier
     */
    async zapierTestAuthenticationRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/integrations/zapier/authenticate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Test authentication for Zapier
     */
    async zapierTestAuthentication(initOverrides) {
        const response = await this.zapierTestAuthenticationRaw(initOverrides);
        return await response.value();
    }
    /**
     * Poll trigger endpoint for new attachments
     */
    async zapierTriggerNewAttachmentsRaw(requestParameters, initOverrides) {
        if (requestParameters.zapierTriggerNewAttachmentsOptions === null || requestParameters.zapierTriggerNewAttachmentsOptions === undefined) {
            throw new runtime.RequiredError('zapierTriggerNewAttachmentsOptions', 'Required parameter requestParameters.zapierTriggerNewAttachmentsOptions was null or undefined when calling zapierTriggerNewAttachments.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/integrations/zapier/triggers/new-attachments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.zapierTriggerNewAttachmentsOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Poll trigger endpoint for new attachments
     */
    async zapierTriggerNewAttachments(requestParameters, initOverrides) {
        const response = await this.zapierTriggerNewAttachmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Poll trigger endpoint for new contacts
     */
    async zapierTriggerNewContactsRaw(requestParameters, initOverrides) {
        if (requestParameters.zapierTriggerNewContactsOptions === null || requestParameters.zapierTriggerNewContactsOptions === undefined) {
            throw new runtime.RequiredError('zapierTriggerNewContactsOptions', 'Required parameter requestParameters.zapierTriggerNewContactsOptions was null or undefined when calling zapierTriggerNewContacts.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/integrations/zapier/triggers/new-contacts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.zapierTriggerNewContactsOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Poll trigger endpoint for new contacts
     */
    async zapierTriggerNewContacts(requestParameters, initOverrides) {
        const response = await this.zapierTriggerNewContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Poll trigger endpoint for new received emails
     */
    async zapierTriggerNewEmailsRaw(requestParameters, initOverrides) {
        if (requestParameters.zapierTriggerNewEmailsOptions === null || requestParameters.zapierTriggerNewEmailsOptions === undefined) {
            throw new runtime.RequiredError('zapierTriggerNewEmailsOptions', 'Required parameter requestParameters.zapierTriggerNewEmailsOptions was null or undefined when calling zapierTriggerNewEmails.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/integrations/zapier/triggers/new-emails`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.zapierTriggerNewEmailsOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Poll trigger endpoint for new received emails
     */
    async zapierTriggerNewEmails(requestParameters, initOverrides) {
        const response = await this.zapierTriggerNewEmailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Poll trigger endpoint for new inboxes
     */
    async zapierTriggerNewInboxesRaw(requestParameters, initOverrides) {
        if (requestParameters.zapierTriggerNewInboxesOptions === null || requestParameters.zapierTriggerNewInboxesOptions === undefined) {
            throw new runtime.RequiredError('zapierTriggerNewInboxesOptions', 'Required parameter requestParameters.zapierTriggerNewInboxesOptions was null or undefined when calling zapierTriggerNewInboxes.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // API_KEY authentication
        }
        const response = await this.request({
            path: `/integrations/zapier/triggers/new-inboxes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.zapierTriggerNewInboxesOptions,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Poll trigger endpoint for new inboxes
     */
    async zapierTriggerNewInboxes(requestParameters, initOverrides) {
        const response = await this.zapierTriggerNewInboxesRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const ZapierGetNewAttachmentRecordsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const ZapierGetNewContactRecordsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const ZapierGetNewEmailRecordsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
/**
 * @export
 */
export const ZapierGetNewInboxRecordsSortEnum = {
    ASC: 'ASC',
    DESC: 'DESC'
};
